import { Injectable, Type } from '@angular/core';
import { Observable } from 'rxjs';
import { componentsInclude } from '../helpers/bottom-menu.utils';
import {
    BottomMenuItem,
    BottomMenuState,
} from '../models/bottom-menu-state.model';

@Injectable({
    providedIn: 'root',
})
export class BottomMenuService {
    private readonly state: BottomMenuState;

    constructor() {
        this.state = new BottomMenuState();
    }

    getComponentsStream(): Observable<BottomMenuItem[]> {
        return this.state.components$.asObservable();
    }

    getComponents(): BottomMenuItem[] {
        return this.state.components$.getValue();
    }

    removeComponent(component: Type<any>): void {
        this.state.components$.next([
            ...this.state.components$
                .getValue()
                .filter((c) => !(c.type === component)),
        ]);
    }

    addComponent(component: BottomMenuItem, prepend = false): void {
        if (componentsInclude(this.state.components$.getValue(), component.id))
            return;

        this.state.components$.next(
            prepend
                ? [component, ...this.state.components$.getValue()]
                : [...this.state.components$.getValue(), component],
        );
    }
}
